<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm rounded-4 mb-4">
  <div class="container-fluid px-4 px-lg-5">
    <a class="navbar-brand fw-bold text-success" href="#">TaitoPoint.fi</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto align-items-lg-center">
        <li class="nav-item">
          <a class="nav-link active text-success fw-semibold" aria-current="page" href="#">Dashboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-muted" href="#">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-muted" href="#">About</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
